import { render, staticRenderFns } from "./PlaylistWidgetPanel.vue?vue&type=template&id=e427a62a&scoped=true"
import script from "./PlaylistWidgetPanel.vue?vue&type=script&lang=js"
export * from "./PlaylistWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./PlaylistWidgetPanel.vue?vue&type=style&index=0&id=e427a62a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e427a62a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e427a62a')) {
      api.createRecord('e427a62a', component.options)
    } else {
      api.reload('e427a62a', component.options)
    }
    module.hot.accept("./PlaylistWidgetPanel.vue?vue&type=template&id=e427a62a&scoped=true", function () {
      api.rerender('e427a62a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layoutDesigner/editor/settingPanel/PlaylistWidgetPanel.vue"
export default component.exports